import { useTranslation } from "@ecliptica/i18n";
import { Button, EmptyState } from "@ecliptica/ui";
import { Link } from "react-router";

export function NotFoundPage() {
  const { t } = useTranslation("common");
  return (
    <EmptyState title={t("error.notFound")} className="mt-10">
      <Button asChild variant="outline" className="mt-3">
        <Link to="/">{t("action.back")}</Link>
      </Button>
    </EmptyState>
  );
}
